import MapEvents from './events';
import MapMarkers from './markers';
import MapRoutes from './routes';
import Ghosts from './ghosts';

class Map extends HTMLElement {
  static observedAttributes = ['type', 'center', 'zoom', 'cluster', 'light'];

  constructor() {
    super();
    this.map = null;
    this.zoom = 4;
    this.light = false;

    this.events = null;
    this.markers = null;
    this.routes = null;
  }

  connectedCallback() {
    // Listen for 'height' attribute changes
    this.parentElement.addEventListener('transitionend', (event) => {
      console.log('transitionend', event.propertyName);
      if (event.propertyName === 'height') {
        this.map.resize();
      }
    });

    this.initialize();
    this.markers = new MapMarkers(this);
    this.routes = new MapRoutes(this);
    this.ghosts = new Ghosts(this);

    this.events = new MapEvents(this);
    this.events.attach();
  }

  get type() {
    return this.getAttribute('type');
  }

  get cluster() {
    return this.getAttribute('cluster') !== 'false'; // Default to true
  }

  attributeChangedCallback(name, oldValue, newValue) {
    console.log('attributeChangedCallback', name, oldValue, newValue);
    switch (name) {
      case 'center':
        this.center = JSON.parse(newValue);
        break;
      case 'zoom':
        this.zoom = parseInt(newValue);
        break;
      case 'light':
        this.light = newValue;
        break;
    }
  }

  disconnectedCallback() {
    this.map?.remove();
    this.events?.detach();
  }

  initialize() {
    mapboxgl.accessToken = bevr.mapboxAccessToken;
    if (!mapboxgl.accessToken) {
      console.log('No access token');
    }
    this.map = new mapboxgl.Map({
      container: this,
      style: this.light ? 'mapbox://styles/mapbox/light-v9' : 'mapbox://styles/mapbox/streets-v9',
      center: this.center ? this.center : [12.554729, 55.70651],
      zoom: this.zoom,
      attributionControl: false,
      pitch: 40,
    });
    this.map.scrollZoom.disable();
    this.map.on('wheel', (event) => {
      if (event.originalEvent.altKey) {
        this.map.scrollZoom.enable();
      } else {
        this.map.scrollZoom.disable();
      }
    });
    this.map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'bottom-right');
  }

  centerOnBound(markers = this.markers.markers, routes = this.routes.routes) {
    const bounds = new mapboxgl.LngLatBounds();
    if (markers.length) {
      markers.forEach((marker) => {
        bounds.extend(marker.geometry.coordinates);
      });
    }
    if (routes.points) {
      Object.values(routes.points).forEach((route) => {
        route.forEach((coord) => {
          bounds.extend(coord);
        });
      });
    }
    if (!bounds.isEmpty()) {
      this.map.fitBounds(bounds, {
        padding: 100,
        duration: 800,
        maxZoom: Math.max(this.map.getZoom(), 10), // Allow closer zoom if already zoomed in
        pitch: 40,
      });
    }
  }
}

customElements.define('map-view', Map);
